class RegistrationCollection extends require("lib/static-shim").default(
  require("lib/core/collection").default
) {
  static initClass() {
    this.prototype.model = require("./registration").default
  }

  url() {
    if (this.options != null ? this.options.resource_id : undefined) {
      return this.urlRoot(
        `api/private/library/resource/${this.options.resource_id}/registration/`
      )
    } else {
      return this.urlRoot(`/api/private/registration/`)
    }
  }
}
RegistrationCollection.initClass()

export default RegistrationCollection
